import type { PropsWithChildren } from 'react'
import { Children } from 'react'

import classNames from 'classnames'
import styled, { css } from 'styled-components'

import { easeOutQuart } from 'theme/animations'
import { space } from 'theme/utils'

type AnimatedChildrenContainerProps = PropsWithChildren<{
  $show: boolean
  $childrenCount: number
  className?: string
}>

const Container = styled.section<AnimatedChildrenContainerProps>`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;

  align-items: center;
  padding: ${space(14)} ${space(4)};
  text-align: center;
  flex-direction: column;
  gap: ${space(10)};
  h2 {
    margin-bottom: -${space(6)};
  }
  > * {
    transform-origin: 50% 50%;
    opacity: 0;
    transition:
      transform 1000ms ${easeOutQuart},
      opacity 1200ms ${easeOutQuart};
    transform: translateY(30px) scale(0.9);
  }

  ${({ $childrenCount }) =>
    new Array($childrenCount).fill(null).map(
      (_, index) => css`
        > *:nth-child(${index + 1}) {
          transition-delay: ${index * 150 + 'ms'};
        }
      `,
    )}

  ${({ $show }) =>
    $show &&
    css`
      > * {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    `}
`

export function AnimatedChildrenContainer({
  $show,
  children,
  className,
}: Pick<
  AnimatedChildrenContainerProps,
  '$show' | 'children' | 'className'
>): JSX.Element {
  const childrenCount = Children.count(children)
  return (
    <Container
      className={classNames(className)}
      $show={$show}
      $childrenCount={childrenCount}
    >
      {children}
    </Container>
  )
}
